<div class="content-wrapper container-xxl p-0 card">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.religious_inquiries' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Users
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text mr-1">{{ 'MENU.DASHBOARD.religious_inquiries_list' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
           <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage" class="mr-2">{{ 'MENU.DASHBOARD.SHOW' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm mr-2"
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="mr-1">{{ 'MENU.DASHBOARD.ENTRIES' | translate }}</span>
              </div>
            </div>
          </div> 
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="">{{ 'MENU.DASHBOARD.SEARCH' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.SEARCH' | translate }}"
                class="form-control form-control-sm w-75"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
  
        <ngx-datatable
          [rows]="arrCoupons" 
          [rowHeight]="58"
          class="bootstrap core-bootstrap bg-white"
          [limit]="itemsPerPage"
          [columnMode]="ColumnMode.force"
          [headerHeight]="40"
          [footerHeight]="50"
          [scrollbarH]="true"
                      [messages]="{ totalMessage: lang == 'ar' ? 'العدد الكلي' : 'total' }"

        >
          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ID' | translate }}"
            prop="id"
            [width]="100"
          ></ngx-datatable-column>

       
<ngx-datatable-column
  [name]="lang == 'ar' ? 'العنوان' : 'Title'"
  [width]="200">
  <ng-template ngx-datatable-cell-template let-row="row">
    <strong>{{ row.title }}</strong>
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column
  [name]="lang == 'ar' ? 'السؤال' : 'Question'"
  [width]="350">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.question ? (row.question.length > 40 ? (row.question | slice:0:40) + '...' : row.question) : '' }}
  </ng-template>
</ngx-datatable-column>


<ngx-datatable-column
  [name]="lang == 'ar' ? 'تاريخ الإرسال' : 'Created At'"
  [width]="180">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.created_at | date:'medium' }}
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column
  [name]="lang == 'ar' ? 'التصنيف' : 'Category'"
  [width]="180">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.category?.name || (lang == 'ar' ? 'غير محدد' : 'N/A') }}
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column
  [name]="lang == 'ar' ? 'الحالة' : 'Status'"
  [width]="140">
  <ng-template ngx-datatable-cell-template let-row="row">
    <span
      class="badge"
      [ngClass]="row.status === 'pending' ? 'badge-light-warning' : 'badge-light-success'">

      {{ row.status === 'pending'
          ? (lang == 'ar' ? 'قيد الانتظار' : 'Pending')
          : (lang == 'ar' ? 'تم الرد' : 'answered') }}

    </span>
  </ng-template>
</ngx-datatable-column>

<ngx-datatable-column
  [name]="lang == 'ar' ? 'الإجابة' : 'Answer'"
  [width]="300">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.answer ? (row.answer.length > 80 ? (row.answer | slice:0:80) + '...' : row.answer) : (lang == 'ar' ? 'لم يتم الرد بعد' : 'Not answered yet') }}
  </ng-template>
</ngx-datatable-column>

          <ngx-datatable-column
            name="{{ 'MENU.DASHBOARD.ACTIONS' | translate }}"
            [width]="100"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div ngbDropdown container="body">
                <button
                  type="button"
                  class="btn btn-sm hide-arrow"
                  ngbDropdownToggle
                >
                  <i data-feather="more-vertical"></i>
                </button>
                <div ngbDropdownMenu>



<a
  *ngIf="row.status === 'pending'"
  ngbDropdownItem
  (click)="openAnswerModal(row.id)"
  class="d-flex align-items-center"
>
  <i
    data-feather="check-circle"
    class="text-success mx-1"
  ></i>

  <span>
    {{ lang == 'ar' ? 'إرسال الإجابة' : 'Answer' }}
  </span>
</a>

      
                  <a ngbDropdownItem (click)="confirmDelete(row.id)" class="d-flex align-items-center">
                    <i data-feather="trash" class="mx-1"></i>
                    <span>{{ "MENU.DASHBOARD.DELETE" | translate }}</span>
                  </a>
             
                </div>
              </div> 
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable> 
      </section>
    </div>
  </div>
  


  <!-- Message Modal -->
<div
  class="modal fade"
  id="messageModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">
          {{ lang === 'ar' ? 'الرسالة' : 'Message' }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body">
        <p class="mb-0" style="white-space: pre-line;">
          {{ selectedMessage }}
        </p>
      </div>

    </div>
  </div>
</div>



<div class="answer-modal" *ngIf="showAnswerModal">

  <div class="answer-modal-box">

    <h5>
      {{ lang == 'ar' ? 'إرسال الإجابة' : 'Send Answer' }}
    </h5>

    <textarea
      class="form-control mt-3"
      rows="5"
      [(ngModel)]="answerText"
      placeholder="{{ lang == 'ar' ? 'اكتب الإجابة هنا...' : 'Write the answer...' }}">
    </textarea>

    <div class="d-flex justify-content-end mt-3">

      <button
        class="btn btn-secondary mr-2 ml-2"
        (click)="showAnswerModal=false">

        {{ lang == 'ar' ? 'إلغاء' : 'Cancel' }}

      </button>

      <button
        class="btn btn-success"
        (click)="submitAnswer()">

        {{ lang == 'ar' ? 'إرسال' : 'Submit' }}

      </button>

    </div>

  </div>

</div>